import { useState } from "react"

import { TTaskAutomation } from "src/data/taskManagement/taskAutomationTypes"
import { TTaskTemplate } from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { MSettingsCard } from "src/ui/MCard/MSettingsCard"
import { MCircularProgress } from "src/ui/MCircularProgress/MCircularProgress"

import { TaskAutomationManageDialog } from "./TaskAutomationsManageDialog"

export function TaskAutomationCard({
  title,
  description,
  taskAutomation,
  templates,
  isLoading,
  onSubmit,
}: {
  title: string
  description: string
  taskAutomation: TTaskAutomation
  templates: TTaskTemplate[]
  isLoading: boolean
  onSubmit: (enabled: boolean, templateId: string | undefined) => void
}) {
  const template = templates.find(
    (template) => template.template_id === taskAutomation.template_id
  )
  const { t, langKeys } = useTranslate()
  const [manageOpen, setManageOpen] = useState(false)

  const pills = [
    {
      label: t(langKeys.automation),
      id: "status",
      isOn: taskAutomation.enabled,
    },
    {
      label: t(langKeys.template),
      id: "template",
      isOn: taskAutomation.enabled,
      value: template?.title,
      hidden: !taskAutomation.enabled,
    },
  ]

  return (
    <MSettingsCard
      title={title}
      description={description}
      labeledPills={isLoading ? [] : pills}
      onManageClick={() => setManageOpen(true)}
    >
      {isLoading && <MCircularProgress size={30} />}
      {manageOpen && (
        <TaskAutomationManageDialog
          onClose={() => setManageOpen(false)}
          onSubmit={onSubmit}
          taskAutomation={taskAutomation}
          title={title}
          description={description}
        />
      )}
    </MSettingsCard>
  )
}
